import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Preloader from "../components/preloader/Preloader";
import Footer from "../components/footer/Footer";
import { Container, Row, Col } from "react-bootstrap";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import EmployeeRestrictionsSection from '../components/employeeRestrictions/employeeRestrictionssection'
import { PageCardShimmer } from "../components/preloader/PageCardShimmer";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import { getAuthorizedBranchIds } from "../../utils/branchScope";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";

const GET_EMPLOYEETYES = gql`
query($id:Int){
    getEmployeeTypes(id:$id){
        id
        employee_type 
      }
}
`

const GET_COLLEGEMODULES = gql`
query($institute_id:Int $branch_id : Int){
    getCollegeModules(institute_id:$institute_id branch_id : $branch_id){
        id
        module_name
      }
}
`

const GET_CLASSES = gql`
query($id:Int){
    getExamClasses(id:$id){
        id
        class
      }
}
`

const GET_BRANCHES = gql`
  query($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
        stream_id
        subjects {
          subject_id
          subject_name
        }
      }
    }
  }
`;

const GET_EMPLOYEE_DETAILS = gql`
query($institute_id:Int,$branch_id:Int){
    getEmployeeDetails(institute_id:$institute_id,branch_id:$branch_id){
        employee_name
        username
        emp_email
        institute_id
        branch_id
        branch_name
        employee_type
        employee_role_id
        role_name
        moduleAcsess{
          module_name
          enabled
        }
        subject_ids
        class_ids
        password
        employeeId
        emp_mobile
        profile_image
        section_ids
        section_names
      }
}
`

class EmployeeRestrictions extends Component {
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {

        if (Cookies.get("token") == undefined) this.props.history.push("/login");

        const getEmployeeTypes = this.props.getEmployeeTypes;
        const loading = getEmployeeTypes.loading
        const error = getEmployeeTypes.error;

        const getCollegeModules = this.props.getCollegeModules;
        const loading2 = getCollegeModules.loading
        const error2 = getCollegeModules.error

        const getEmployeeDetails = this.props.getEmployeeDetails;
        const loading4 = getEmployeeDetails.loading;
        const error4 = getEmployeeDetails.error;

        const getExamClasses = this.props.getExamClasses;
        const loading5 = getExamClasses.loading;
        const error5 = getExamClasses.error;

        const getBranches = this.props.getBranches;
        const loading6 = getBranches.loading;
        const error6 = getBranches.error;

        // Show only the branches the user is authorized for. The branch_id cookie is a
        // comma-separated list (e.g. "10,12,15"), so match against every authorized id.
        const authorizedIds = getAuthorizedBranchIds();
        const authorizedBranches = authorizedIds.length
            ? (getBranches.getBranches || []).filter((b) => authorizedIds.includes(String(b.id)))
            : (getBranches.getBranches || []);

        // Subjects now come from the branch sections instead of a separate globals call.
        // Flatten every section's subjects, de-duplicate by id, and keep the {id, subject}
        // shape the downstream restriction components already expect.
        const subjectsById = new Map();
        authorizedBranches.forEach((branch) => {
            (branch.sections || []).forEach((section) => {
                (section.subjects || []).forEach((subject) => {
                    if (subject.subject_id != null && !subjectsById.has(subject.subject_id)) {
                        subjectsById.set(subject.subject_id, {
                            id: subject.subject_id,
                            subject: subject.subject_name,
                        });
                    }
                });
            });
        });
        const globals = { offlineExamSubjects: Array.from(subjectsById.values()) };

        if (error !== undefined) {
            alert("Server Error. " + error.message);
            return null;
        }
        if (error4 !== undefined) {
            alert("Server Error. " + error4.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }
        if (error6 !== undefined) {
            alert("Server Error. " + error6.message);
            return null;
        }
        return (

            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        <Container fluid>
                            {
                                loading || loading2 || loading4 || loading5 || loading6 ?
                                    (
                                        <PageCardShimmer filters={4} />
                                    )
                                    :
                                    (
                                        <EmployeeRestrictionsSection
                                            getEmployeeTypes={getEmployeeTypes.getEmployeeTypes}
                                            getCollegeModules={getCollegeModules.getCollegeModules}
                                            globals={globals}
                                            getEmployeeDetails={getEmployeeDetails.getEmployeeDetails}
                                            refetchEmployees={getEmployeeDetails.refetch}
                                            getExamClasses={getExamClasses.getExamClasses}
                                            getBranches={authorizedBranches}
                                        />

                                    )
                            }
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(
    compose(
        graphql(GET_EMPLOYEETYES, {
            options: (props) => ({
                variables: {
                    id: 0,
                },
            }),
            name: "getEmployeeTypes",
        }),
        graphql(GET_COLLEGEMODULES, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id:parseInt(Cookies.get("branch_id"))
                },
                fetchPolicy: 'network-only'
            }),
            name: "getCollegeModules",
        }),
        graphql(GET_EMPLOYEE_DETAILS, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    // Scope employees to the user's branch when they have exactly one
                    // authorized branch; admins / multi-branch users see all (0).
                    branch_id: getAuthorizedBranchIds().length === 1 ? parseInt(getAuthorizedBranchIds()[0]) : 0
                },
            }),
            name: "getEmployeeDetails",
        }),
        graphql(GET_CLASSES, {
            options: (props) => ({
                variables: {
                    id: 1,
                },
            }),
            name: "getExamClasses",
        }),
        graphql(GET_BRANCHES, {
            options: (props) => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                },
            }),
            name: "getBranches",
        }),
    )(EmployeeRestrictions)
);